import axios from "../api";

export function getDataByAdvancedSearch(data) {
  return axios.post("dataset/advanced-search", data);
}